import { render, staticRenderFns } from "./my-radio.vue?vue&type=template&id=1ae9d288&scoped=true"
import script from "./my-radio.vue?vue&type=script&lang=js"
export * from "./my-radio.vue?vue&type=script&lang=js"
import style0 from "./my-radio.vue?vue&type=style&index=0&id=1ae9d288&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae9d288",
  null
  
)

export default component.exports